export default __webpack_public_path__ + "static/media/image-3.0a23d3e8.jpeg";